import { useEffect } from 'react';
import { axiosSecurity } from './axios';
import useRefreshToken from './useRefreshToken';
import { useAuth } from './useAuth';
const { TOKEN_NAME } = require('../helper/application-conf').default;
import { StorageService } from '../helper/storage-service';

const useAxiosSecurity = () => {
  const refresh = useRefreshToken();
  const { auth } = useAuth() as any;
  const storage = new StorageService();
  useEffect(() => {
    const authToken = JSON.parse(storage.getSession(TOKEN_NAME) as any) || null;
    const requestIntercept = axiosSecurity.interceptors.request.use(
      (config) => {
        if (config.headers && !config.headers.Authorization) {
          config.headers.Authorization = `Bearer ${authToken?.accessToken}`;
        }
        return config;
      }, (error) => Promise.reject(error)
    );

    const responseIntercept = axiosSecurity.interceptors.response.use(
      (response) => response,
      async (error) => {
        const errorObj = JSON.parse(JSON.stringify(error));
        const prevRequest = error?.config;
        if (errorObj?.status === 401 && !prevRequest?.sent) {
          prevRequest.sent = true;
          const newAccessToken = await refresh();
          storage.setSession(TOKEN_NAME, newAccessToken);
          prevRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return axiosSecurity(prevRequest);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosSecurity.interceptors.request.eject(requestIntercept);
      axiosSecurity.interceptors.response.eject(responseIntercept);
    };
  }, [auth, refresh]);

  return axiosSecurity;
};

export default useAxiosSecurity;
